const globalUrls: any = {
  baseUrl: {
    prod: 'https://tcms.esign.cn/api/v1', // 生产
    sml: 'https://tcms.esign.cn/api/v1', // 模拟,参考新官网，由于新官网没有模拟环境，所以这里和生产环境保持一致， 接口由刹那，无恙负责
    other: 'http://120.26.93.6:8891/api/v1', // 开发及测试
  },
  eBaseUrl: {
    // 登录相关
    prod: 'https://tapi.esign.cn', // 生产
    sml: 'https://smltapi.esign.cn', // 模拟
    other: 'http://ttapi.tsign.cn', // 开发及测试
  },
  accountWebServer: {
    prod: 'https://tapi.esign.cn/account-webserver', // 生产
    sml: 'https://smltapi.esign.cn/account-webserver', // 模拟
    other: 'https://ttapi.tsign.cn/account-webserver', // 开发及测试
  },
  webServer: {
    prod: 'https://tapi.esign.cn/webserver', // 生产
    sml: 'https://smltapi.esign.cn/webserver', // 模拟
    other: 'https://ttapi.tsign.cn/webserver', // 开发及测试
  },
  eBaseUrl2: {
    // 表单相关
    prod: 'https://eapi.esign.cn', // 生产
    sml: 'http://120.26.93.6:13001', // 模拟
    other: 'http://helios.test.cn:13001', // 开发及测试
  },
  numUrl: {
    // 数字接口
    // https://data-api.esign.cn:9443/api/v0.1/globleSignAggregationModified
    // https://data-api.esign.cn:9444/analysis-java/api/v0.1/globleSignAggregationModified
    prod: 'https://data-api.esign.cn:9444/analysis-java/api/v0.1/globleSignAggregationModified', // 生产
    sml: 'https://data-api.esign.cn:9444/analysis-java/api/v0.1/globleSignAggregationModified', // 模拟
    other: 'https://data-api.esign.cn:9444/analysis-java/api/v0.1/globleSignAggregationModified', // 开发及测试
  },
  checkEsignFile: {
    // 文件验证
    prod: 'https://tcms.esign.cn/api/v1', // 生产
    sml: 'https://smltapi.esign.cn/api/v1', // 模拟
    other: 'http://120.26.93.6:8891/api/v1', // 开发及测试
  },
  cdnBaseUrl: 'https://asset.tsign.cn',
  tsignDataSdkUrl: 'https://asset.tsign.cn/tsign-sdk/tsigndata-sdk-js/v1.0.7/tsigndata-sdk-js.js',
  routerBaseOpt: '/',
  trial: {
    prod: 'https://m.esign.cn', // 生产
    sml: 'https://testmanage.esign.cn', // 模拟
    other: 'https://testmanage.esign.cn', // 开发及测试
  },
}

// 配置基础api
export default (function () {
  const config: any = {}
  Object.keys(globalUrls).forEach((key: any) => {
    const urls = globalUrls[key]
    config[key] = urls[process.env.VUE_APP_MODE || process.env.environment || process.env.mode] || urls.other || urls
  })
  console.log(process.env)

  return config
})()
